// De vaste afsluiting van een helpdeskmail, aan de schermkant.
//
// De server (backend/src/util/mailGroet.js) maakt de groet, zet ze onder elk
// sjabloon en elk AI-voorstel, en haalt slotformules uit standaardteksten. Het
// scherm hoeft alleen te weten WAAR de groet in de tekst begint, zodat een
// standaardtekst of kennisbankartikel er altijd BOVEN komt en nooit eronder —
// dat is de afspraak waardoor de groet nooit dubbel staat.
//
// De herkenning (SLOT) is een kopie van die op de server — houd beide gelijk.

export const SLOT = /(heb je (nog |bijkomende |verdere |andere )?vragen\b|(nog|bijkomende|verdere) vragen\?|vous avez (encore |d.autres )?(des )?questions|(any |further |other )?questions\s*\?\s*(don.t|do not) hesitate|met (energieke|vriendelijke|hartelijke|sportieve|warme) groet(en)?|\b(vriendelijke|hartelijke|energieke) groet(en)?|salutations( énergiques| distinguées| cordiales)?|cordialement|bien à vous|meilleures salutations|kind regards|best regards|(warm|energetic) regards)/i;
const MAX_STAART = 260;
const platteTekst = (h) => String(h || '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();
const BLOK_OPEN = /<(p|div|br|li|h[1-6])\b[^>]*>/gi;

// Waar begint de slotformule in deze HTML, of -1.
export function slotPositie(html) {
  const s = String(html || '');
  let beste = -1;
  const re = new RegExp(SLOT.source, 'gi');
  let m;
  while ((m = re.exec(s))) {
    if (platteTekst(s.slice(m.index)).length <= MAX_STAART) { beste = m.index; break; }
  }
  if (beste < 0) return -1;
  let blokStart = -1; let blokTag = '';
  let b;
  const re2 = new RegExp(BLOK_OPEN.source, 'gi');
  while ((b = re2.exec(s)) && b.index < beste) { blokStart = b.index; blokTag = b[1].toLowerCase(); }
  if (blokStart >= 0 && !platteTekst(s.slice(blokStart, beste))) return blokStart;
  if (blokStart >= 0 && blokTag === 'br') return blokStart;
  return beste;
}

// Fragment invoegen vóór de groet; zonder groet gewoon achteraan. `tussen` is
// wat er tussen bestaande tekst en het fragment komt (bv. een lege regel).
export function voegVoorGroet(html, fragment, tussen = '') {
  const s = String(html || '');
  const f = String(fragment || '');
  const p = slotPositie(s);
  if (p < 0) return s.trim() ? `${s}${tussen}${f}` : f;
  const voor = s.slice(0, p);
  return `${voor}${voor.trim() ? tussen : ''}${f}${s.slice(p)}`;
}
